import '@/assets/css/payment-function.scss';
import { mapState } from "vuex";

// Extend
import basePaymentService from '@/scripts/payment/basePaymentService';

// Component
import ManualPayment from "@/views/Payment/ManualPayment.vue";
import PaymentGateway from "@/views/Payment/PaymentGateway.vue";
import CouponRecharge from "@/views/Payment/CouponRecharge.vue";

export default {

  components: {
    ManualPayment,
    PaymentGateway,
    CouponRecharge
  },

  computed: {
    ...mapState({
      user: state => state.auth.user,
    }),
  },

  extends: basePaymentService,

  data() {
    return {
    }
  },

  created() {

  },
}